export default __webpack_public_path__ + "static/media/pravnici.fd08ed98.jpg";